import { render, staticRenderFns } from "./Schema.vue?vue&type=template&id=6f6b493f&scoped=true"
import script from "./Schema.vue?vue&type=script&lang=js"
export * from "./Schema.vue?vue&type=script&lang=js"
import style0 from "./Schema.vue?vue&type=style&index=0&id=6f6b493f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6b493f",
  null
  
)

export default component.exports